import { DRAWER_WIDTH, SIDEBAR_BG, OFF_WHITE } from "../../constants/layout";

export const drawerPaperSx = {
  width: DRAWER_WIDTH,
  boxSizing: "border-box",
  bgcolor: SIDEBAR_BG,
  borderRight: "none",
  color: OFF_WHITE,
  overflow: "visible",
};
